import { Play } from "lucide-react";

export default function Hero() {
  return (
    <section className="w-full bg-brand-martinique relative overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-8 lg:px-[135px] py-20 lg:py-[157px]">
        {/* Decorative Dotted Shape */}
        <div className="absolute bottom-[198px] right-[569px] w-[93px] h-[93px] hidden lg:block">
          <img
            src="https://api.builder.io/api/v1/image/assets/TEMP/8e5671b823af3fe4967a8177de25037848ab2bb9?width=186"
            alt=""
            className="w-full h-full"
          />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8 lg:space-y-10">
            <div className="space-y-6">
              <h1 className="hero-title font-agency font-bold text-brand-orange leading-[0.86]">
                Your right to know<br />
                Our Ai to show
              </h1>
              <p className="font-kepler text-text-lg-custom text-white max-w-[470px]">
                Something big is coming. Stay tuned for launch.
              </p>
            </div>

            <div className="flex items-center gap-4">
              <button className="flex items-center gap-3 px-7 py-3 bg-[#31A8FF] text-white font-agency text-text-md-custom font-bold rounded-md hover:bg-[#2890E0] transition-colors">
                Get Started
                <div className="flex items-center justify-center w-6 h-6 bg-white rounded-full">
                  <Play size={12} className="text-[#31A8FF] fill-[#31A8FF]" />
                </div>
              </button>
            </div>
          </div>

          {/* Right Content - HOLE Logo with Astronaut */}
          <div className="relative flex items-center justify-center lg:justify-end">
            <div className="relative w-full max-w-[491px]">
              <img
                src="https://api.builder.io/api/v1/image/assets/TEMP/e19b8ef9c6017b745440a499672ce138f4e85fd0?width=984"
                alt="HOLE Foundation"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
